import { makeStyles, OutlinedInput } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((_theme) => ({
  root: {
    margin: 0,
    padding: 0,
    height: "44px",
  },
  input: {
    padding: "8px",
  },
}));

const TableInputField = (props: React.ComponentProps<typeof OutlinedInput>) => {
  const styles = useStyles();

  return <OutlinedInput classes={styles} {...props} />;
};

export default TableInputField;
